// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsEfsFilesystemsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-efs-filesystems_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M33 29h1v4.5a.5.5 0 0 1-.5.5H29v-1h3.3l-3.65-3.65.7-.7L33 32.29zm-21.65.35L7.71 33H11v1H6.5a.5.5 0 0 1-.5-.5V29h1v3.3l3.65-3.65zM34 6.5V11h-1V7.7l-3.65 3.65-.7-.7L32.29 7H29V6h4.5c.28 0 .5.22.5.5M7 11H6V6.5c0-.28.22-.5.5-.5H11v1H7.7l3.65 3.65-.7.7L7 7.71zm5.47 5.31q0 .35.05.68a.5.5 0 0 1-.38.54c-1.06.27-2.85 1.09-2.85 3.63v.24a3.7 3.7 0 0 0 2.54 3.28l-.33.95a4.7 4.7 0 0 1-3.2-4.47 4.5 4.5 0 0 1 3.18-4.48v-.37a6.7 6.7 0 0 1 3.83-5.89 6.5 6.5 0 0 1 7.25 1.43q.9.9 1.47 2.13c1.6-1.26 4.5-.7 4.9 2.58 2.49.64 3.85 2.27 3.85 4.63 0 2.6-1.41 3.7-2.6 4.17l-.36-.93q1.97-.77 1.96-3.24 0-3.01-3.42-3.74a.5.5 0 0 1-.4-.45c-.1-1.83-1.14-2.65-2.12-2.65-.61 0-1.2.3-1.59.83a.5.5 0 0 1-.87-.14 7 7 0 0 0-1.52-2.48 5.5 5.5 0 0 0-6.16-1.21 5.7 5.7 0 0 0-3.23 4.96M26 29H14v-7.5q0-.33.1-.43c.09-.08.27-.08.4-.07h1.4c.27 0 .49-.23.5-.5 0-.1.07-.34.13-.5h1.86c.04.15.09.38.09.5 0 .28.22.5.5.5h6.7q.15 0 .16.04c.08.07.16.29.16.7zm2.3-6.5L27 26.42V22.5zm1.18-.34a.5.5 0 0 0-.48-.66h-2.02q-.05-.8-.45-1.2a1.1 1.1 0 0 0-.89-.3h-6.23c-.08-.4-.28-.91-.76-1H16.3c-.5 0-.72.56-.83 1h-.95q-.69-.05-1.1.34-.43.4-.43 1.16v8c0 .28.22.5.5.5h13a.5.5 0 0 0 .47-.34z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-efs-filesystems_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsEfsFilesystems",
);
export default AwsEfsFilesystemsIcon;
